import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../misc.module';
import { WalkingFarmRoutingModule } from './walking-farm-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, WalkingFarmRoutingModule, IonicModule, MiscModule, ReactiveFormsModule]
})
export class WalkingFarmModule {}
